import React, { useState, useEffect } from 'react';
import timelineData from '../story/the-missing-hour/timeline.json';
import './Timeline.css';

function Timeline({ isOpen, onClose }) {
  const [selectedDay, setSelectedDay] = useState(0);
  const [currentDay, setCurrentDay] = useState(1);

  useEffect(() => {
    if (isOpen) {
      setCurrentDay(2); // We're on day 2, so day 3+ are disabled
      setSelectedDay(1); // Default to showing day 1
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleDayClick = (day) => {
    setSelectedDay(day);
  };

  const getDayEvents = (day) => {
    return timelineData.timeline.find(dayData => dayData.day === day)?.events || [];
  };

  const getDayTitle = (day) => {
    return timelineData.timeline.find(dayData => dayData.day === day)?.title || `Day ${day}`;
  };



  return (
    <div className="timeline-page">
      <div className="timeline-header">
        <h2 className="timeline-title">TIMELINE</h2>
        <button className="timeline-close-btn" onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>
      </div>

        <div className="timeline-days">
          {Array.from({ length: 7 }, (_, i) => {
            const dayNumber = i + 1;
            return (
              <div
                key={i}
                className={`timeline-day ${selectedDay === i ? 'selected' : ''} ${i <= currentDay ? 'available' : 'locked'}`}
                onClick={() => i <= currentDay && handleDayClick(i)}
              >
                <div className="day-label">DAY</div>
                <div className="day-number">{dayNumber}</div>
              </div>
            );
          })}
        </div>

                     <div className="timeline-content">
               <div className="timeline-day-header">
                 <h3 className="day-title">Day {selectedDay + 1} - {getDayTitle(selectedDay)}</h3>
               </div>

          <div className="timeline-events">
            {getDayEvents(selectedDay).map((event, index) => (
              <div key={index} className="timeline-event">
                <div className="event-time">{event.time}</div>
                <div className="event-content">
                  <div className="event-title">{event.event}</div>
                  <div className="event-location">{event.location}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
    </div>
  );
}

export default Timeline;
